<template>
    <rkm-overlay>
        <rkm-layout-body title="Dispensação de medicamento">
            <template v-slot:actions>
                <rkm-button
                    @click.stop="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    v-if="hasPermissaoAtualizacaoCadastroPaciente"
                    @click="handleBuscarDadosPacienteIntegracaoCns"
                    color="info"
                >
                    Buscar dados do paciente no CADSUS
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.save()"
                    color="outline-success"
                    :disabled ="isObito"
                >
                    Finalizar
                </rkm-button>
            </template>

            <template
                v-if="paciente"
                v-slot:subtitle
            >

                <div class="sub-title">
                    <rkm-icon class="icon" icon="user"/>
                    <span class="text-uppercase" v-if="paciente.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                        {{ paciente.cidadao.nome }} <strong>({{ paciente.cidadao.nomeSocial }})</strong>,
                    </span>
                    <span class="text-uppercase" v-else>
                        {{ paciente.cidadao.nome }},
                    </span>
                    <span v-if="paciente.cidadao.idade">
                        {{ paciente.cidadao.idade.anos }} anos,
                        {{ paciente.cidadao.idade.meses }} meses
                        e {{ paciente.cidadao.idade.dias }} dias,
                    </span>
                    <span>{{ paciente.cidadao.sexo.descricao }}</span>
                </div>
            </template>

            <rkm-layout-content>
                <Form
                    :fila-id="filaId"
                    :pacienteId="pacienteId"
                    @loaded="loaded"
                    @paciente="handlePaciente"
                    @save="handleSave"
                    ref="Form"
                />
            </rkm-layout-content>

            <ModalIntegracaoCns
                @update="handleIntegracaoCnsUpdate"
                ref="ModalIntegracaoCns"
            />
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/farmacia/dispensacao/Form'
import ModalIntegracaoCns from '@/components/integracao/cns/components/busca//Modal'

// Vuex.
import { mapActions } from 'vuex'

// Enums
import classificacao from '@/enums/cadastro/paciente/classificacao'
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

// Mixins.
import {error, repository, unmask} from '@/mixins'

export default {
    components: {
        Form,
        ModalIntegracaoCns,
    },
    computed: {
        hasPermissaoAtualizacaoCadastroPaciente() {
            let hasPermissao = false

            if (this.additionals && this.additionals.permissoesAtualizacaoCadastroPaciente) {
                if (this.form && this.form.paciente.classificacaoId === this.enums.classificacao.MUNICIPE && this.additionals.permissoesAtualizacaoCadastroPaciente.municipe) {
                    hasPermissao = true
                }
                else if (this.form && this.form.paciente.classificacaoId === this.enums.classificacao.PROVISORIO && this.additionals.permissoesAtualizacaoCadastroPaciente.provisorio) {
                    hasPermissao = true
                }
                else if (this.form && this.form.paciente.classificacaoId === this.enums.classificacao.OUTRO_MUNICIPIO && this.additionals.permissoesAtualizacaoCadastroPaciente.outroMunicipio) {
                    hasPermissao = true
                }
            }

            return hasPermissao
        },
    },
    created() {
        this.repositories = {
            filaAtendimento: this.getConectaSusRepository('farmacia.filaAtendimento'),
        }
        this.setShowExitFormConfirmation()
    },
    data: () => ({
        additionals: null,
        enums: {classificacao, preferenciaNome},
        form: null,
        paciente: null,
        isObito:false
    }),
    methods: {
        ...mapActions([
            'setLoading',
            'unsetLoading',
            'setShowExitFormConfirmation',
            'unsetShowExitFormConfirmation'
        ]),
        loaded(value) {

            this.additionals = value.additionals
            this.form = value.form

            if (this.additionals.enderecoDesatualizadoBloqueado) {

                this.unsetShowExitFormConfirmation()

                this.showAlert(
                    'O endereço do paciente ainda não foi atualizado pela Base Nacional. Atualize o cadastro para continuar.',
                    'Atenção'
                )

                this.redirectToList()
            }
        },
        handleExit() {
            this.showExitConfirmation(async () => {
                if (this.filaId) {
                    this.setLoading()

                    return await this.repositories.filaAtendimento.sendBack(this.filaId)
                        .then(() => {
                            this.unsetShowExitFormConfirmation()
                            this.redirectToList()
                        })
                        .finally(() => {
                            this.unsetLoading()
                        })
                } else {
                    this.unsetShowExitFormConfirmation()
                    this.redirectToList()
                }
            })
        },
        handleSave() {

            this.unsetShowExitFormConfirmation()
            this.redirectToList()
        },
        redirectToList() {
            if(this.filaId) {
                this.$router.push({ name: 'farmacia-fila-atendimento-index' })
            } else {
                this.$router.push({ name: 'farmacia-dispensacao-index', params: { relatorio: false }})
            }

        },
        handlePaciente(paciente) {            
            this.paciente = paciente

            if(paciente.cidadao?.obito?.obitoEm){
                this.isObito = true
            }
        },
        handleBuscarDadosPacienteIntegracaoCns() {
            const params = {
                id: this.form.paciente.cidadao.id,
                nome: this.form.paciente.cidadao.nome,
                dataNascimento: this.form.paciente.cidadao.dataNascimento,
                nomeMae: this.form.paciente.cidadao.nomeMae,
                cns: this.form.paciente.cidadao.cns ? this.unMaskCns(this.form.paciente.cidadao.cns) : null,
                cpf: this.form.paciente.cidadao.cpf ? this.unMaskCpf(this.form.paciente.cidadao.cpf) : null,
            }

            this.$refs.ModalIntegracaoCns.open(params)
        },
        handleIntegracaoCnsUpdate(item) {
            Object.assign(this.form.paciente.cidadao, {
                ...item,
                cns: item.cns ? this.unMaskCns(item.cns) : null,
                cpf: item.cpf ? this.unMaskCpf(item.cpf) : null,
            })
        },
    },
    mixins: [error, repository, unmask],
    props: {
        filaId: { type: Number, default: null },
        pacienteId: { type: Number, default: null },
    },
}
</script>

<style scoped>
.sub-title {
    font-size: 13px;
    text-transform: uppercase;
    color: #222;
}
</style>